/**
 * Esse arquivo é responsável por definir os tipos de custo por tipo de anúncio.
 * [01/10/2025 @brenonovelli]
 * Atualmente está sendo usado para montarmos o payload da edição.
 * Como evolução, podemos usar para montar as seções de investimento.
 */

type CostByType = {
  cpc: CampaignAdType[]
  cpm: CampaignAdType[]
}

export const costByAdType: CostByType = {
  cpc: ['product', 'sponsored_brand', 'sponsored_brand_video'],
  cpm: [
    'banner',
    'sponsored_brand',
    'sponsored_brand_video',
    'banner_video',
    'banner_off_site'
  ]
}
